<script>
  import {getContext} from 'svelte';
  import {IMAGES} from '../images';
  import lang from '../HomePage.lang';

  const LG = getContext('LG');

  const introductions = [
    {
      img: IMAGES.HEART,
      title: LG(lang.JpIntroduction1_Title),
      desc: LG(lang.JpIntroduction1_Desc),
    },
    {
      img: IMAGES.HAND_HEART,
      title: LG(lang.JpIntroduction2_Title),
      desc: LG(lang.JpIntroduction2_Desc),
    },
    {
      img: IMAGES.TALK,
      title: LG(lang.JpIntroduction3_Title),
      desc: LG(lang.JpIntroduction3_Desc),
    },
  ];
</script>

<style>
  .introductions-wrapper {
    padding-bottom: 80px;
    background: #fff;
  }
  .introductions {
    padding: 80px 0;
    width: 100%;
    text-align: center;
    background: #45e555;
  }
  .inner {
    display: inline-flex;
    justify-content: space-between;
    width: 1200px;
    gap: 24px;
  }
  .introduction {
    flex: 1;
    border-radius: 12px;
    padding: 24px;
    background: rgba(255, 255, 255, 0.9);
  }
  .title {
    padding: 24px 0;
    font-weight: 700;
    font-size: 20px;
  }
  .desc {
    font-weight: 400;
    font-size: 12px;
    color: #4e4e4e;
  }
  @media screen and (max-width: 640px) {
    .inner {
      display: block;
      box-sizing: border-box;
      width: 100%;
    }
    .introductions {
      box-sizing: border-box;
      padding: 24px;
      width: 100%;
    }
    .introduction {
      margin-top: 24px;
      box-sizing: border-box;
      width: 100%;
    }
  }
</style>

<div class="introductions-wrapper">
  <div class="introductions">
    <div class="inner">
      {#each introductions as intro}
        <div class="introduction">
          <img height="28" src={intro.img} />
          <div class="title">{intro.title}</div>
          <div class="desc">{intro.desc}</div>
        </div>
      {/each}
    </div>
  </div>
</div>
